export const FONT_GROUPS = [
    {
        label: "Sans-Serif",
        fonts: [
            "Arial, sans-serif", "Helvetica, sans-serif", "Inter, system-ui, sans-serif",
            "Roboto, sans-serif", "Open Sans, sans-serif", "Lato, sans-serif",
            "Poppins, sans-serif", "Montserrat, sans-serif", "Nunito, sans-serif",
            "Raleway, sans-serif", "Source Sans 3, sans-serif", "Work Sans, sans-serif",
            "DM Sans, sans-serif", "Plus Jakarta Sans, sans-serif", "Manrope, sans-serif",
            "IBM Plex Sans, sans-serif", "Noto Sans, sans-serif", "Ubuntu, sans-serif",
            "Fira Sans, sans-serif", "Barlow, sans-serif", "Outfit, sans-serif",
            "Figtree, sans-serif", "Geist Sans, sans-serif",
        ],
    },
    {
        label: "Serif",
        fonts: [
            "Georgia, serif", "Times New Roman, serif", "Garamond, serif",
            "Merriweather, serif", "Playfair Display, serif", "Lora, serif",
            "PT Serif, serif", "Libre Baskerville, serif", "Source Serif 4, serif",
            "IBM Plex Serif, serif", "Noto Serif, serif", "Crimson Text, serif",
            "EB Garamond, serif",
        ],
    },
    {
        label: "Monospace",
        fonts: [
            "Courier New, monospace", "Consolas, monospace", "Menlo, monospace",
            "Monaco, monospace", "Source Code Pro, monospace", "JetBrains Mono, monospace",
            "Fira Code, monospace", "IBM Plex Mono, monospace", "Roboto Mono, monospace",
            "Geist Mono, monospace",
        ],
    },
    {
        label: "Display",
        fonts: [
            "Impact, sans-serif", "Comic Sans MS, cursive", "Bebas Neue, sans-serif",
            "Oswald, sans-serif", "Anton, sans-serif", "Righteous, sans-serif",
        ],
    },
];

export const DEFAULT_DESIGN_SYSTEM = {
    colors: {
        primary: "#18181b",
        primaryForeground: "#fafafa",
        secondary: "#f4f4f5",
        secondaryForeground: "#18181b",
        accent: "#f4f4f5",
        accentForeground: "#18181b",
        background: "#ffffff",
        foreground: "#09090b",
        muted: "#f4f4f5",
        mutedForeground: "#71717a",
        destructive: "#ef4444",
        destructiveForeground: "#fafafa",
        border: "#e4e4e7",
        ring: "#18181b",
    },
    typography: {
        fontFamily: "Inter, system-ui, sans-serif",
        headingWeight: "700",
        bodySize: "16px",
    },
    components: {
        buttonShape: "rounded",
        borderRadius: "0.5rem",
    },
    layout: {
        navStyle: "sidebar",
        maxWidth: "1400px",
        spacingScale: "default",
    },
};

export const TEMPLATES = [
    {
        name: "Default",
        description: "Neutral shadcn defaults",
        ...DEFAULT_DESIGN_SYSTEM,
    },
    {
        name: "Corporate Blue",
        description: "Banking & enterprise",
        colors: {
            primary: "#1e3a5f",
            primaryForeground: "#ffffff",
            secondary: "#e8eef4",
            secondaryForeground: "#1e3a5f",
            accent: "#2563eb",
            accentForeground: "#ffffff",
            background: "#f8fafc",
            foreground: "#0f172a",
            muted: "#e2e8f0",
            mutedForeground: "#64748b",
            destructive: "#dc2626",
            destructiveForeground: "#ffffff",
            border: "#cbd5e1",
            ring: "#2563eb",
        },
        typography: {
            fontFamily: "IBM Plex Sans, sans-serif",
            headingWeight: "600",
            bodySize: "16px",
        },
        components: { buttonShape: "rounded", borderRadius: "0.375rem" },
        layout: { navStyle: "sidebar", maxWidth: "1400px", spacingScale: "default" },
    },
    {
        name: "Modern Dark",
        description: "Dark mode first, vibrant accent",
        colors: {
            primary: "#a78bfa",
            primaryForeground: "#0f0a1a",
            secondary: "#1e1b2e",
            secondaryForeground: "#e2e0ea",
            accent: "#22d3ee",
            accentForeground: "#0f172a",
            background: "#0f0a1a",
            foreground: "#f8fafc",
            muted: "#1e1b2e",
            mutedForeground: "#94a3b8",
            destructive: "#f43f5e",
            destructiveForeground: "#ffffff",
            border: "#2d2a3e",
            ring: "#a78bfa",
        },
        typography: {
            fontFamily: "DM Sans, sans-serif",
            headingWeight: "700",
            bodySize: "16px",
        },
        components: { buttonShape: "rounded", borderRadius: "0.75rem" },
        layout: { navStyle: "sidebar", maxWidth: "1400px", spacingScale: "default" },
    },
    {
        name: "Warm Earth",
        description: "Organic & consulting",
        colors: {
            primary: "#78350f",
            primaryForeground: "#fefce8",
            secondary: "#fef3c7",
            secondaryForeground: "#78350f",
            accent: "#d97706",
            accentForeground: "#ffffff",
            background: "#fffbeb",
            foreground: "#451a03",
            muted: "#fef3c7",
            mutedForeground: "#92400e",
            destructive: "#dc2626",
            destructiveForeground: "#ffffff",
            border: "#fde68a",
            ring: "#d97706",
        },
        typography: {
            fontFamily: "Merriweather, serif",
            headingWeight: "700",
            bodySize: "16px",
        },
        components: { buttonShape: "rounded", borderRadius: "0.5rem" },
        layout: { navStyle: "sidebar", maxWidth: "1200px", spacingScale: "spacious" },
    },
    {
        name: "Ocean",
        description: "Healthcare & fintech",
        colors: {
            primary: "#0d9488",
            primaryForeground: "#ffffff",
            secondary: "#ccfbf1",
            secondaryForeground: "#134e4a",
            accent: "#06b6d4",
            accentForeground: "#ffffff",
            background: "#f0fdfa",
            foreground: "#042f2e",
            muted: "#ccfbf1",
            mutedForeground: "#5eead4",
            destructive: "#ef4444",
            destructiveForeground: "#ffffff",
            border: "#99f6e4",
            ring: "#0d9488",
        },
        typography: {
            fontFamily: "Source Sans 3, sans-serif",
            headingWeight: "600",
            bodySize: "16px",
        },
        components: { buttonShape: "rounded", borderRadius: "0.5rem" },
        layout: { navStyle: "top-nav", maxWidth: "1400px", spacingScale: "default" },
    },
    {
        name: "Monochrome",
        description: "Minimal black & white",
        colors: {
            primary: "#000000",
            primaryForeground: "#ffffff",
            secondary: "#f5f5f5",
            secondaryForeground: "#171717",
            accent: "#404040",
            accentForeground: "#ffffff",
            background: "#ffffff",
            foreground: "#0a0a0a",
            muted: "#f5f5f5",
            mutedForeground: "#737373",
            destructive: "#dc2626",
            destructiveForeground: "#ffffff",
            border: "#e5e5e5",
            ring: "#000000",
        },
        typography: {
            fontFamily: "Helvetica, Arial, sans-serif",
            headingWeight: "800",
            bodySize: "16px",
        },
        components: { buttonShape: "square", borderRadius: "0px" },
        layout: { navStyle: "sidebar", maxWidth: "1200px", spacingScale: "compact" },
    },
    {
        name: "Vibrant",
        description: "Marketing & consumer",
        colors: {
            primary: "#7c3aed",
            primaryForeground: "#ffffff",
            secondary: "#fce7f3",
            secondaryForeground: "#831843",
            accent: "#f97316",
            accentForeground: "#ffffff",
            background: "#ffffff",
            foreground: "#1e1b4b",
            muted: "#ede9fe",
            mutedForeground: "#6b21a8",
            destructive: "#e11d48",
            destructiveForeground: "#ffffff",
            border: "#ddd6fe",
            ring: "#7c3aed",
        },
        typography: {
            fontFamily: "Poppins, sans-serif",
            headingWeight: "700",
            bodySize: "16px",
        },
        components: { buttonShape: "pill", borderRadius: "1rem" },
        layout: { navStyle: "top-nav", maxWidth: "1600px", spacingScale: "spacious" },
    },
];
